import {Loader} from './Spinner.module.css';


export default function Spinner(){
    return <div className={Loader}>Loading...</div>
}